import { jsxs as t, jsx as e, Fragment as o } from "react/jsx-runtime";
import a from "../../_virtual/style.esm.js";
import s from "./styles.esm.js";
const x = ({
  labels: r = {
    error: {
      failText1: "",
      failText2: ""
    },
    noResult: {
      noProductsText1: "",
      noProductsText2: ""
    }
  },
  isNoResult: n = !1,
  isError: c = !1
}) => {
  const l = () => /* @__PURE__ */ t(o, { children: [
    /* @__PURE__ */ e(a, { id: s.__hash, children: s }),
    /* @__PURE__ */ t("div", { className: `jsx-${s.__hash} fail-fetching`, children: [
      /* @__PURE__ */ e("img", { src: "https://images.sodimac.com/v3/assets/blt6a203fe6c6a9b6dd/blt3205b6418c5526f7/error-home.svg", alt: "Failed secondary products", className: `jsx-${s.__hash} no-products-image` }),
      /* @__PURE__ */ e("span", { className: `jsx-${s.__hash} fail-fetching-text-1`, children: r.error.failText1 }),
      /* @__PURE__ */ e("p", { className: `jsx-${s.__hash} fail-fetching-text-2`, children: r.error.failText2 })
    ] })
  ] }), d = () => /* @__PURE__ */ t(o, { children: [
    /* @__PURE__ */ e(a, { id: s.__hash, children: s }),
    /* @__PURE__ */ t("div", { className: `jsx-${s.__hash} no-products`, children: [
      /* @__PURE__ */ e("img", { src: "https://images.sodimac.com/v3/assets/blt6a203fe6c6a9b6dd/blt32e8d2a317b19756/no-result.svg", alt: "Empty secondary products", className: `jsx-${s.__hash} no-products-image` }),
      /* @__PURE__ */ e("span", { className: `jsx-${s.__hash} no-products-text-1`, children: r.noResult.noProductsText1 }),
      /* @__PURE__ */ e("p", { className: `jsx-${s.__hash} no-products-text-2`, children: r.noResult.noProductsText2 })
    ] })
  ] });
  return /* @__PURE__ */ t("div", { style: {
    backgroundColor: "#FFF",
    width: "100%",
    padding: "20px 60px 60px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }, className: `jsx-${s.__hash} error__container`, children: [
    /* @__PURE__ */ e(a, { id: s.__hash, children: s }),
    c ? l() : null,
    n ? d() : null
  ] });
};
export {
  x as default
};
